//@ts-nocheck
import { Fragment, useEffect, useRef, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useAppDispatch } from "../../app/hooks";
import { ReviewData } from "../../features/review/reviewTypes";
import { toast } from "sonner";
import {
  createReview,
  fetchReviewList,
  fetchReviewDetailsData,
  fetchReviewListByJobId,
  assignReviewTemplateData,
} from "../../features/review/reviewSlice";
import { CustomCheckIcon } from "../icons";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronDownIconWhite } from "../icons";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CrossIcon, ExclamationIcon } from "../icons/Icons";

interface BoardPageProps {
  editBoardData?: any;
  onSaveSuccess?: () => void;
}

const SelectionTabs: React.FC<SelectionTabsProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="flex w-full gap-4 my-6">
      {options.map((option, index) => (
        <button
          key={index}
          type="button"
          onClick={() => {
            onChange(option.value);
            // If Clone tab is selected, trigger the API call
            if (option.value === "approval") {
              onChange(option.value);
              // You might want to call the API here or in the parent component
            } else {
              onChange(option.value);
            }
          }}
          className={`flex items-start gap-3 p-4 w-full rounded-lg border text-left transition-colors ${
            value === option.value
              ? "border-indigo-600 bg-indigo-50"
              : "border-gray-200 hover:bg-gray-50"
          }`}
        >
          <div className="text-indigo-600 mt-[2px]">{option.icon}</div>
          <div>
            <div className="font-medium text-gray-900">{option.title}</div>
            <div className="text-sm text-gray-500">{option.description}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

const CreateReviewTemplateDetails: React.FC<BoardPageProps> = ({
  isModalOpen,
  setIsModalOpen,
  editBoardData,
  setEditBoardData,
}) => {
  const [name, setName] = useState("");
  const [purpose, setPurpose] = useState("");
  const [color, setColor] = useState("bg-[#3b82f6]");
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [content, setContent] = useState("");
  const { userId } = useParams<{ userId: string }>();
  const [emailData, setEmailData] = useState<ReviewData | null>(null);
  const navigate = useNavigate();
  const [loading1, setLoading1] = useState(false);
  const [selectedTab, setSelectedTab] = useState("new");
  const [nameError, setNameError] = useState("");
  const [purposeError, setPurposeError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [createPipelineLoading, setCreatePipelineLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [jobPipeline, setJobPipeline] = useState<any[]>([]);
  const [createPipelineAssignLoadingSave, setCreatePipelineAssignLoadingSave] =
    useState(false);
  const filteredPipelines = jobPipeline?.filter((pipeline: any) =>
    pipeline.review_name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const onTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
  };

  useEffect(() => {
    if (selectedTab === "approval") {
      // Call the API to fetch scorecard list
      const fetchScorecards = async () => {
        setCreatePipelineLoading(true);
        try {
          // Fetch data
          const baseResponse = await dispatch(fetchReviewList(baseId));

          if (baseResponse?.payload) {
            setJobPipeline(baseResponse.payload.data);
          } else {
            setJobPipeline([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setJobPipeline([]);
          toast.error("Failed to fetch pipeline details");
        } finally {
          setCreatePipelineLoading(false);
        }
      };

      fetchScorecards();
    }
  }, [selectedTab, baseId, dispatch]);

  const tabOptions = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-square-rounded-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
          <path d="M15 12h-6" />
          <path d="M12 9v6" />
        </svg>
      ),
      title: "Create New",
      description: "Create new review template",
      value: "new",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-copy-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
          <path d="M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
          <path d="M11 14h6" />
          <path d="M14 11v6" />
        </svg>
      ),
      title: "Clone",
      description: "Clone exiting review template",
      value: "approval",
    },
  ];

  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];
  const isEditMode = Boolean(userId);
  const [cursorPosition, setCursorPosition] = useState(0);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const { jobId } = useParams<{ jobId: string }>();

  // Fetch email details when in edit mode
  useEffect(() => {
    const fetchEmailDetails = async () => {
      if (isEditMode && userId && baseId) {
        setLoading1(true);
        try {
          const response = await dispatch(
            fetchReviewDetailsData({
              baseId: Number(baseId),
              userId,
            }),
          );

          if (response.payload && typeof response.payload === "object") {
            const responseData = response.payload;

            // Check if we have the email data
            if (responseData.data && typeof responseData.data === "object") {
              const emailDetails = responseData.data;

              setEmailData({
                id: Number(emailDetails.id) || 0,
                review_name: emailDetails.review_name || "",
                // email_subject: emailDetails.email_subject || '',
                review_details: emailDetails.review_details || "",
                colour: emailDetails.colour || "",
                base_id: Number(emailDetails.base_id) || 0,
                status: emailDetails.status || "",
                ai_check: emailDetails.ai_created === "yes" || "",
              });

              // Update form fields
              setName(emailDetails.review_name || "");
              // setPurpose(emailDetails.email_subject || '');
              setContent(emailDetails.review_details || "");
              // Remove 'bg-[' prefix if it exists in the color value
              setColor(
                emailDetails.colour
                  ? emailDetails.colour.startsWith("#")
                    ? `bg-[${emailDetails.colour}]`
                    : `bg-[#${emailDetails.colour}]`
                  : "bg-[#3b82f6]",
              );
              setChecked(emailDetails.ai_created === "yes");
            } else {
              console.error(
                "Review details not found in response:",
                responseData,
              );
              toast.error("Review template details not found");
            }
          } else {
            console.error("Invalid response payload:", response.payload);
            toast.error("Failed to load review template data");
          }
        } catch (error) {
          console.error("Error fetching review details:", error);
          toast.error("Failed to fetch review details");
        } finally {
          setLoading1(false);
        }
      }
    };

    fetchEmailDetails();
  }, [userId, baseId, dispatch, isEditMode]);

  useEffect(() => {
    const storedData = localStorage.getItem("jobByReviewData");
    if (storedData) {
      setBaseTeamsData(JSON.parse(storedData));
    }
  }, []);

  // Form submission handler
  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setNameError("");
    setPurposeError("");

    if (name.trim().length === 0) {
      setNameError("Name is required");
      setLoading(false);
      return;
    }

    const colorValue = color.substring(
      color.indexOf("[#") + 1,
      color.indexOf("]"),
    );

    const payload: createTeamsPayload = {
      base_id: baseId,
      review_name: name,
      // email_subject: purpose,
      colour: colorValue,
      review_details: content,
      ai_created: checked ? "yes" : "no",
      job_id: jobId,
    };

    try {
      const response = await dispatch(
        createReview({ payload, userId: baseId }),
      );
      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Review created successfully!");
      } else {
        toast.error("Failed to create review.");
      }
      if (response?.payload?.status === 200) {
        setIsModalOpen(false);
        // Fetch updated list
        const baseResponse = await dispatch(
          fetchReviewListByJobId({
            baseId: Number(baseId),
            jobId: jobId,
          }),
        );

        if (baseResponse?.payload) {
          localStorage.setItem(
            "jobByReviewData",
            JSON.stringify(baseResponse.payload),
          );
          window.dispatchEvent(
            new StorageEvent("storage", {
              key: "jobByReviewData",
              newValue: JSON.stringify(baseResponse.payload),
            }),
          );
        }
      }

      resetForm();
    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setPurpose("");
    setContent("");
    setColor("bg-[#3b82f6]");
    setChecked(false);
    // setEditBoardData(null);  // Add this line
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
    } else if (name === "purpose") {
      setPurpose(value);
    } else if (name === "content") {
      setContent(value);
    }
  };

  const handleAssignPipeline = async () => {
    if (!baseId || !jobId || !selectedTemplate?.id) {
      toast.error("Invalid Base ID, Job ID, or Pipeline Template");
      return;
    }

    setCreatePipelineAssignLoadingSave(true);

    try {
      const response = await dispatch(
        assignReviewTemplateData({
          baseId: parseInt(baseId, 10),
          userId: selectedTemplate.id,
          JobId: jobId,
        }),
      );

      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Review Template assigned successfully!");

        const baseResponse = await dispatch(
          fetchReviewListByJobId({
            baseId: Number(baseId),
            jobId: jobId,
          }),
        );

        if (baseResponse?.payload) {
          localStorage.setItem(
            "jobByReviewData",
            JSON.stringify(baseResponse.payload),
          );
          window.dispatchEvent(
            new StorageEvent("storage", {
              key: "jobByReviewData",
              newValue: JSON.stringify(baseResponse.payload),
            }),
          );
        }

        setIsModalOpen(false); // Close the modal on success
        setSelectedTemplate("");

        // localStorage.setItem('jobByReviewData', JSON.stringify(baseResponseData.payload));
      } else {
        throw new Error(response.payload || "Failed to assign pipeline");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to assign pipeline");
    } finally {
      setCreatePipelineAssignLoadingSave(false);
    }
  };
  // insert chips
  const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPurpose(e.target.value);
    setCursorPosition(e.target.selectionStart);
  };

  const handleTextAreaClick = (e: React.MouseEvent<HTMLTextAreaElement>) => {
    const target = e.target as HTMLTextAreaElement;
    setCursorPosition(target.selectionStart);
  };

  const handleTextAreaKeyUp = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const target = e.target as HTMLTextAreaElement;
    setCursorPosition(target.selectionStart);
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={setIsModalOpen}
      className="relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 
                   data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all
                        data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in 
                        sm:my-8 sm:w-full sm:max-w-[34rem] sm:p-4 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-[0px] top-[3px] hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={() => setIsModalOpen(false)}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <CrossIcon />
              </button>
            </div>
            <div className="flex flex-col gay-y-4">
              <DialogTitle
                as="h3"
                className="text-base font-medium text-gray-900"
              >
                Assign Review
              </DialogTitle>
              <div className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[8px]"></div>
              <SelectionTabs
                options={tabOptions}
                value={selectedTab}
                onChange={setSelectedTab}
              />

              {selectedTab === "approval" && (
                <div className="mt-[5px]">
                  <div className="mt-0">
                    {/* <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mt-1.5'>Template Name</label> */}
                    <input
                      type="text"
                      placeholder="Search Template"
                      value={searchTerm}
                      // onKeyDown={handleKeyPress}

                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="px-3 py-[10px] w-[100%] border mt-0 border-gray-200 border-solid  rounded-t-lg text-sm border-b-0 focus:outline-none focus:ring-0 focus:ring-gray-200 focus:border-gray-200"
                    />
                  </div>
                  <div className="overflow-x-hidden">
                    <table className="min-w-full divide-y divide-x divide-gray-200">
                      <tbody className="bg-white divide-y rounded-b-lg block divide-gray-200 border border-solid border-[#e5e7eb] overflow-y-auto max-h-[400px] h-full">
                        {createPipelineLoading ? (
                          <tr className="flex items-center justify-center">
                            <td colSpan={4} className="px-6 py-4 text-center">
                              <div className="flex items-center justify-center relative z-50">
                                <div className="simple-spinner-loader">
                                  <span></span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : filteredPipelines.length > 0 ? (
                          filteredPipelines.map(
                            (template: any, index: number) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() => onTemplateSelect(template)}
                                  className={`flex items-center px-2 pt-[6px] pb-[7px] cursor-pointer w-full ${selectedTemplate?.id === template.id ? "bg-indigo-50" : ""}`}
                                >
                                  <div>
                                    {template?.colour && (
                                      <div className="flex shrink-0 pr-0 mt-[0px]">
                                        <span
                                          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                          style={{
                                            backgroundColor: template?.colour,
                                          }}
                                        >
                                          {template.review_name[0]}
                                        </span>
                                      </div>
                                    )}
                                  </div>

                                  <div className="flex flex-col">
                                    <td
                                      className="px-4 pt-0 pb-[0px] text-[#1b1b1b] text-[13px] font-normal
                             whitespace-nowrap  overflow-hidden text-ellipsis w-[400px] capitalize"
                                    >
                                      {template.review_name}
                                    </td>
                                    {template.review_details && (
                                      <td className="px-4 pt-0 pb-0">
                                        <span className="text-[13px] text-[#5c5c5e]  rounded-md px-0 leading-4 capitalize line-clamp-1 max-w-[400px]">
                                          {template.review_details}
                                        </span>
                                      </td>
                                    )}
                                  </div>
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr className="flex items-center justify-center">
                            <td
                              colSpan={4}
                              className="px-6 py-4 text-center text-sm text-gray-500"
                            >
                              <div className="w-full mt-5 flex justify-center items-center flex-col gap-y-3">
                                <ExclamationIcon />
                                <p className="text-[#0000007a] text-[13px]">
                                  No results found
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="flex items-center justify-end gap-[22px] pt-4 flex-wrap md:flex-nowrap lg:flex-nowrap">
                    <button
                      type="submit"
                      className="inline-flex items-center relative justify-center whitespace-nowrap rounded-md bg-indigo-600 font-medium leading-normal help-btn-setting text-[#fefeff] min-w-[32px] h-[32px] px-[14px] text-[0.8125rem]"
                      onClick={handleAssignPipeline}
                    >
                      <div className="flex items-center flex-row-reverse gap-[6px]">
                        {createPipelineAssignLoadingSave ? (
                          <div className="flex items-center  gap-[6px]">
                            Create
                            <div className="simple-spinner">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          "Create"
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              )}

              {selectedTab === "new" && (
                <form action="#" className="space-y-6 mt-0">
                  <div className="flex flex-col gap-y-2">
                    <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                      Name
                    </label>
                    <div className="relative">
                      <Menu as="div" className="flex items-center">
                        <Menu.Button className="absolute inset-y-0 left-0 flex items-center px-2">
                          <div
                            className={`h-6 w-6 rounded-full ${color} border flex justify-center items-center`}
                          >
                            <ChevronDownIconWhite />
                          </div>
                        </Menu.Button>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                            {colorList.map((value, index) => (
                              <div
                                onClick={() => setColor(value.name)}
                                key={index}
                                className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center cursor-pointer`}
                              >
                                {color === value.name && <CustomCheckIcon />}
                              </div>
                            ))}
                          </Menu.Items>
                        </Transition>
                        <input
                          id="name"
                          name="name"
                          type="text"
                          value={name}
                          onChange={handleInputChange}
                          placeholder="Enter Name"
                          className="w-full px-4 py-2 pl-10 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                        />
                      </Menu>
                    </div>
                    {nameError && (
                      <p className="text-sm text-red-600">{nameError}</p>
                    )}

                    <div className="flex flex-col gap-y-2 mt-1">
                      <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                        Description
                      </label>

                      <textarea
                        ref={textAreaRef}
                        value={purpose}
                        onChange={handleTextAreaChange}
                        onClick={handleTextAreaClick}
                        onKeyUp={handleTextAreaKeyUp}
                        rows={12}
                        className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
            focus:ring-indigo-500 transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600   focus:outline 
            focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
             border-[#d1d1db]
            dark:border-surface-100 focus:outline-indigo-600  rounded-[0.375rem]"
                        placeholder="Enter your template content here..."
                      />
                      {purposeError && (
                        <p className="text-sm text-red-600">{purposeError}</p>
                      )}
                    </div>
                  </div>
                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="!mt-4 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                    <button
                      type="button"
                      onClick={handleSave}
                      className=" inline-flex shrink-0  justify-center items-center gap-1 rounded-md bg-indigo-600 px-[14px] py-1 h-[32px] text-[13px] font-medium leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      {loading ? (
                        <div className="flex items-center  gap-[6px]">
                          Save
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="mt-3 inline-flex w-full justify-center items-center rounded-md bg-white px-[14px] py-2 text-[13px] h-[32px] font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default CreateReviewTemplateDetails;
